import axios from "axios";
import CookieService from "./cookieService";
import {logout} from "./logout";
import {toast} from "react-toastify";
import {getUrl} from "../constants/urls";
import {isEmpty} from "lodash";

const defaultHeaders = {
  "Content-Type": "application/json",
};

const requestProcess = axios.create({
  baseURL: import.meta.env?.VITE_API_BASE_URL,
  headers: defaultHeaders,
});
export default requestProcess;

const refreshProcess = axios.create({
  baseURL: import.meta.env?.VITE_API_BASE_URL,
  headers: defaultHeaders,
});

requestProcess.interceptors.request.use((req) => {
  const access = CookieService().getAccessToken();
  if (access) {
    req.headers.Authorization = `Bearer ${access || ""}`;
    try {
      if (JSON.parse(localStorage.getItem("customer"))?.id) {
        req.headers["X-CUSTOMER-ID"] = JSON.parse(localStorage.getItem("customer")).id;
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn("Customer not set in local storage");
    }
  }

  return req;
});

requestProcess.interceptors.response.use(
  async (response) => {
    if (response?.status === 204) {
      toast.success("Record Deleted Successfully");
    } else {
      // Toaster display on user actions only. Like Add, Edit, Delete
      if (!isEmpty(response?.data?.message) && response?.config?.method !== "get") {
        toast.success(response.data.message);
      }
    }
    return response;
  },
  (error) => {
    if (error?.response?.status === 400) {
      const error_message = error?.response?.data?.data;
      if (!isEmpty(error_message)) {
        for (const prop in error_message) {
          toast.error(`${error_message[prop]}`);
        }
      } else {
        toast.error(error?.response?.data?.message);
      }
    } else if (error?.response?.status === 401) {
      try {
        const refreshToken = CookieService().getRefreshToken();
        const rememberMe = CookieService().getRememberMe();
        if (rememberMe && refreshToken) {
          return refreshProcess
            .post(getUrl("refresh"), {refresh: refreshToken})
            .then(({data}) => {
              CookieService().setAppToken(data, false);
              return requestProcess.request(error?.config).then((data) => {
                return data;
              });
            })
            .catch(() => {
              toast.error(error?.response?.data?.message);
              logout();
              if (!error?.config?.url?.includes("login")) {
                window.location.reload();
              }
            });
        } else {
          toast.error(error?.response?.data?.message);
          logout();
          if (!error?.config?.url?.includes("login")) {
            window.location.reload();
          }
        }
      } catch (error) {
        toast.error(error?.response?.data?.message);
        logout();
        if (!error?.config?.url?.includes("login")) {
          window.location.reload();
        }
      }
    } else if (error?.response?.status === 500) {
      toast.error("Internal server error occurred, contact your administrator");
    } else {
      // Capture permission error using detail, falling back to the "error"
      // key some endpoints use instead, and finally a generic message so a
      // response body we don't recognize never results in an empty toast.
      toast.error(
        error?.response?.data?.message ||
          error?.response?.data?.detail ||
          error?.response?.data?.error ||
          "Something went wrong. Please try again."
      );
    }

    return Promise.reject(error);
  }
);
